// findOffice.pager.js
export function initFindOfficePager() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-action="prev"],[data-action="next"],[data-action="page"]');
    if (!btn) return;

    const action = btn.dataset.action; // "prev" | "next" | "page"
    const page = parseInt(btn.dataset.page, 10);

    // Notify the parent component or the global state
    // This could be a custom event or a state management action
    const container = btn.closest('.find-office') || document;
    container.dispatchEvent(new CustomEvent('findoffice:page', { detail: { action, page } }));
  });
}
